"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsumerNav = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_intl_1 = require("react-intl");
const ConsumerNav_module_css_1 = __importDefault(require("./ConsumerNav.module.css"));
const ConsumerNavItem_1 = require("./ConsumerNavItem");
/**
 * Renders the consumer navigation items
 */
function ConsumerNav(props) {
    const intl = (0, react_intl_1.useIntl)();
    const ariaLabel = intl.formatMessage({
        id: "m5EFsX",
        defaultMessage: "Consumer Navigation",
        description: "Aria Label for Consumer Navigation",
    });
    return (
    // Navigation order for Consumer Properties needs to be maintained for RTL languages
    (0, jsx_runtime_1.jsx)("nav", { "aria-label": ariaLabel, dir: "ltr", children: (0, jsx_runtime_1.jsx)("ul", { className: ConsumerNav_module_css_1.default.linkList, children: props.items.map((item) => ((0, jsx_runtime_1.jsx)("li", { className: ConsumerNav_module_css_1.default.item, children: (0, jsx_runtime_1.jsx)(ConsumerNavItem_1.ConsumerNavItem, { item: item, active: item.id === props.currentApp, onClick: props.onClick }) }, item.id))) }) }));
}
exports.ConsumerNav = ConsumerNav;
//# sourceMappingURL=ConsumerNav.js.map